<template>
  <v-row>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Empty identities/log</v-card-title>
        <v-card-text>{{emptyIdentitiesResult}}</v-card-text>
        <v-card-actions><v-btn @click="emptyIdentities()"><v-icon right dark>mdi-play</v-icon></v-btn></v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Empty profiles</v-card-title>
        <v-card-text>{{emptyProfilesResult}}</v-card-text>
        <v-card-actions>
          <v-btn @click="emptyProfiles()"><v-icon right dark>mdi-play</v-icon></v-btn>
          <v-btn @click="showProfiles()">show</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Get Size Report</v-card-title>
        <v-card-text>{{sizeReportResult}}</v-card-text>
        <v-card-actions><v-btn @click="sizeReport()"><v-icon right dark>mdi-play</v-icon></v-btn></v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Process all</v-card-title>
        <v-card-text>{{processAllResult}}</v-card-text>
        <v-card-actions>
          <v-btn @click="processAll()"><v-icon right dark>mdi-play</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Process retention</v-card-title>
        <v-card-text>{{processRetentionResult}}</v-card-text>
        <v-card-actions>
          <v-btn @click="processRetention()"><v-icon right dark>mdi-play</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Merge duplicate persons</v-card-title>
        <v-card-text>{{mergeDuplicatePersonsResult}}</v-card-text>
        <v-card-actions>
          <v-btn @click="mergeDuplicatePersons()"><v-icon right dark>mdi-play</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="6" md="3">
      <v-card>
        <v-card-title>Test API error</v-card-title>
        <v-card-text>{{testApiErrorResult}}</v-card-text>
        <v-card-actions>
          <v-btn @click="testApiError()"><v-icon right dark>mdi-play</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" md="6" v-if="sizeReportResultItems">
      <v-card>
      <v-card-title>DB Size Report</v-card-title>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Table</th>
              <th class="text-left">Used (Mb)</th>
              <th class="text-left">Allocated (Mb)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sizeReportResultItems" :key="item.table">
              <td>{{ item.table }}</td>
              <td>{{ item.usedMb }}</td>
              <td>{{ item.allocatedMb }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" md="6" v-if="profiles.length > 0">
      <v-card>
      <v-card-title>Profiles</v-card-title>
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Modified</th>
              <th class="text-left">Name</th>
              <th class="text-left">Delete action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in profiles" :key="item.id">
              <td>{{ $moment.utc(item.modified).local().format("DD-MM-YYYY HH:mm:ss") }}</td>
              <td>{{ item.name }}</td>
              <td><v-icon v-if="item.isDeleted == false"
                    small 
                    @click="removeProfile(item.id)"
                  >delete</v-icon></td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-card-actions><v-btn text color="primary" @click="closeProfiles()">close</v-btn></v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SettingsDatabase",
  props: ["me"],
  data() {
    return {
      sizeReportResult: "Not started",
      emptyIdentitiesResult: "Not started",
      emptyProfilesResult: "Not started",
      processAllResult: "Not started",
      processRetentionResult: "Not started",
      mergeDuplicatePersonsResult: "Not started",
      testApiErrorResult: "Not started",
      sizeReportResultItems: null,
      profiles: []
    };
  },
  methods: {
    sizeReport() {
      this.sizeReportResult = "Started";
      this.sizeReportResultItems = null;
      this.$http
        .get("api/system/listdbsize")
        .then(request => {
          if (request.status == 200) {
            this.sizeReportResult = "Done";
            if (request.data) this.sizeReportResultItems = request.data;
          } else {
            this.sizeReportResult = "Error 1";
          }
        })
        .catch(e => {
          this.sizeReportResult = "Error 2";
          if (e.response) this.sizeReportResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2400", e);
        });
    },
    mergeDuplicatePersons() {
      this.mergeDuplicatePersonsResult = "Started";
      this.$http
        .get("api/system/mergeduplicatepersons")
        .then(request => {
          if (request.status == 200) {
            this.mergeDuplicatePersonsResult = "Done";
            if (request.data) this.mergeDuplicatePersonsResult += " " + request.data + " persons merged.";
          } else {
            this.mergeDuplicatePersonsResult = "Error 1";
          }
        })
        .catch(e => {
          this.mergeDuplicatePersonsResult = "Error 2";
          if (e.response) {
            if (e.response.status == '404') this.mergeDuplicatePersonsResult = "No duplicate persons found";
            else {
              this.mergeDuplicatePersonsResult += " " + e.response.status;
              this.$root.$children[0].$emit("display-error", "2401", e);
            }
          }
        });
    },
    emptyIdentities() {
      this.emptyIdentitiesResult = "Started";
      this.$http
        .get("api/system/emptyidentities")
        .then(request => {
          if (request.status == 200) {
            this.emptyIdentitiesResult = "Done";
            if (request.data) this.emptyIdentitiesResult += " " + request.data + " rows deleted.";
          } else {
            this.emptyIdentitiesResult = "Error 1";
          }
        })
        .catch(e => {
          this.emptyIdentitiesResult = "Error 2";
          if (e.response) this.emptyIdentitiesResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2402", e);
        });
    },
    emptyProfiles() {
      this.emptyProfilesResult = "Started";
      this.$http
        .get("api/system/emptyprofiles")
        .then(request => {
          if (request.status == 200) {
            this.emptyProfilesResult = "Done";
            if (request.data) this.emptyProfilesResult += " " + request.data + " rows deleted.";
          } else {
            this.emptyProfilesResult = "Error 1";
          }
        })
        .catch(e => {
          this.emptyProfilesResult = "Error 2";
          if (e.response) this.emptyProfilesResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2403", e);
        });
    },
    showProfiles() {
      this.$http
          .get("api/identityprofiles/all")
          .then(request => {
            if (request.data && request.data.length > 0) {
              this.profiles = request.data;
            }
          })
          .catch(err => {
            this.$root.$children[0].$emit("display-error", "2404", err);
          });
    },
    closeProfiles() {
      this.profiles = [];
    },
    removeProfile(id) {
      if (this.profiles.find(x => x.id == id)) {
        this.$http
          .delete("api/identityprofiles/" + id)
          .then(request => {
            if (request.status == 200) {
              this.showProfiles();
            }
          })
          .catch((e) => {
            this.$root.$children[0].$emit("display-error", "2405", e);
          });
      }
    },
    processAll() {
      this.$http
          .get("api/identities/processall")
          .then(request => {
          if (request.status == 200) {
            this.processAllResult = "Done";
          } else {
            this.processAllResult = "Error 1";
          }
        })
        .catch(e => {
          this.processAllResult = "Error 2";
          if (e.response) this.processAllResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2406", e);
        });
    },
    processRetention() {
      this.$http
          .get("api/identities/processretention")
          .then(request => {
          if (request.status == 200) {
            this.processRetentionResult = "Done";
          } else {
            this.processRetentionResult = "Error 1";
          }
        })
        .catch(e => {
          this.processRetentionResult = "Error 2";
          if (e.response) this.processRetentionResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2407", e);
        });
    },
    testApiError() {
      this.testApiErrorResult = "GETTING ERROR"
      this.$http
          .get("api/system/returnerror")
          .then(request => {
          if (request.status == 200) {
            this.testApiErrorResult = "WHAT?";
            this.$root.$children[0].$emit("display-error", "2408", "this is weird");
          }
        })
        .catch(e => {
          this.testApiErrorResult = "ERROR!";
          if (e.response) this.testApiErrorResult += " " + e.response.data;
          this.$root.$children[0].$emit("display-error", "2409", e.response.data);
        });
    },
  }
};
</script>